module.exports = __webpack_public_path__ + "img/stepsFour.3154c462.svg";